module.exports = __webpack_public_path__ + "img/500.5b5820ed.png";